//temporário, enquanto nao temos uma integração, o usuário precisa adicionar as disciplinas e solicitar à B42
//para que possamos criar o skin necessário.

/**
 * REGRAS
 */

//aqui irá receber as disciplinas add da tela discover
//enviar post para a ApiAdmin/solicitacoes com id das disciplinas. (configurar laravel com amazon SES)
//https://medium.com/@martin.riedweg/configure-amazon-ses-on-laravel-5-8-in-5-minutes-764c30df6399
//ApiAdmin busca as disciplinas

// se a situação for DIS, monta email com hash, nome, todas unidades_nome e respectivas URLS
// Com essa info, diagramadores vão criar a skin do cliente
//e poderão encaminhar o email para o cliente trocando a pasta ROOT pelo nome do cliente

//se a situação for ATR, monta email com hash, nome, todas unidades_nome
// Com essa info, diagramadores irão diagramar, cadastrar no gael, e responder o email com as URLS

//se a situação for AES, monta email com hash, nome, todas unidades_nome
// Com essa info, entraremos em contato com os professores, depois de pronto os diagramadores irão diagramar, cadastrar no gael, e responder o email com as URLS

import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";
import {
  ADD_DISCIPLINA,
  REMOVE_DISCIPLINA,
  REMOVE_ALL_DISCIPLINAS,
  SEND_SOLICITACAO_EMAIL,
  REMOVE_OBSERVACOES
} from "@/store/actions/actions.type";
import {
  SET_DISCIPLINA,
  UNSET_DISCIPLINA,
  UNSET_ALL_DISCIPLINAS,
  SEND_SOLICITACAO_EMAIL_START,
  SEND_SOLICITACAO_EMAIL_END,
  UNSET_OBSERVACOES
} from "@/store/mutations/mutations.type";

// const defaults = Object.freeze({
//   solicitacao: {
//     disciplinas: []
//   }
// });

const state = {
  solicitacao: {
    //Não usar tipo de dado Set em disciplinas. Seria perfeito para nao deixar duplicar, mas o vue.js 2 não suporta reatividade em Map e Set.
    disciplinas: [],
    observacoes: ""
  },
  lastDisciplinaRemoved: {},
  isSendingSolicitacaoEmail: false
};

const getters = {
  solicitacao(state) {
    return state.solicitacao;
  },
  lastDisciplinaRemoved(state) {
    return state.lastDisciplinaRemoved;
  },
  isSendingSolicitacaoEmail(state) {
    return state.isSendingSolicitacaoEmail;
  }
};

const actions = {
  [ADD_DISCIPLINA](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SET_DISCIPLINA, params);
      resolve();
    });
  },
  [REMOVE_DISCIPLINA](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(UNSET_DISCIPLINA, params);
      resolve();
    });
  },
  [REMOVE_OBSERVACOES](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(UNSET_OBSERVACOES, params);
      resolve();
    });
  },
  [REMOVE_ALL_DISCIPLINAS](context) {
    return new Promise((resolve, reject) => {
      context.commit(UNSET_ALL_DISCIPLINAS);
      resolve();
    });
  },
  [SEND_SOLICITACAO_EMAIL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SEND_SOLICITACAO_EMAIL_START);

      ApiAdmin.post("solicitacoes/sendmail", params)
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(SEND_SOLICITACAO_EMAIL_END);
        });
    });
  }
};

const mutations = {
  [SET_DISCIPLINA](state, disciplina) {
    const found = state.solicitacao.disciplinas.find(
      item => item.id === disciplina.id
    );

    if (found) {
      return;
    }

    if (disciplina.indexAdd == undefined) {
      state.solicitacao.disciplinas.push(disciplina);
    } else {
      state.solicitacao.disciplinas.splice(disciplina.indexAdd, 0, disciplina);
    }
  },
  [UNSET_DISCIPLINA](state, disciplina) {
    let indexAdd;
    const found = state.solicitacao.disciplinas.find((item, index) => {
      indexAdd = index;
      return item.id === disciplina.id;
    });

    state.lastDisciplinaRemoved = { ...found, indexAdd: indexAdd };

    state.solicitacao.disciplinas = state.solicitacao.disciplinas.filter(
      item => {
        return item.id != disciplina.id;
      }
    );
  },
  [UNSET_ALL_DISCIPLINAS](state) {
    state.solicitacao.disciplinas = [];
  },
  [UNSET_OBSERVACOES](state) {
    state.solicitacao.observacoes = "";
  },
  [SEND_SOLICITACAO_EMAIL_START](state) {
    state.isSendingSolicitacaoEmail = true;
  },
  [SEND_SOLICITACAO_EMAIL_END](state) {
    state.isSendingSolicitacaoEmail = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
